// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","nav":"Header_nav__J8WFt","linkActive":"Header_linkActive__TVRWg"};